export enum PopupType {
    ERROR = 'ERROR',
    INFO = 'INFO',
    CUSTOM = 'CUSTOM'
}

export interface ModalOptions {
    content?: string;
    header?: string;
    type: 'ERROR' | 'INFO' | 'CUSTOM';
    data?: any;
    otherConfiguration?: any;
    mode?: string;
    message?: string;
}
